import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { CalendarModule } from "primeng/calendar";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { DatePickerModule } from "primeng/datepicker";

export interface FilterOptionsLazyLoadEvent {
  key: string;
  first?: number;
  rows?: number;
  filter?: string;
}

@Component({
  selector: "app-filter",
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    DropdownModule,
    CalendarModule,
    DatePickerModule,
  ],
  templateUrl: "./filter.component.html",
  styleUrl: "./filter.component.scss",
})
export class FilterComponent {
  @Input() config: any;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
  @Output() searchClicked = new EventEmitter<{ key: string; value: any }>();
  @Output() optionsLazyLoad = new EventEmitter<FilterOptionsLazyLoadEvent>();

  today: Date = new Date();
  private skipNextVirtualScrollLazyLoad = false;

  readonly virtualScrollOptions = {
    lazy: true,
    delay: 100,
    showLoader: false,
    onLazyLoad: (event: { first?: number; rows?: number }) => {
      if (!this.config?.lazy || !this.config?.key) {
        return;
      }

      if (this.skipNextVirtualScrollLazyLoad && (event?.first ?? 0) === 0) {
        this.skipNextVirtualScrollLazyLoad = false;
        return;
      }

      this.skipNextVirtualScrollLazyLoad = false;

      this.optionsLazyLoad.emit({
        key: this.config.key,
        first: event?.first,
        rows: event?.rows,
      });
    },
  };

  onValueChange(val: any) {
    if (
      (Array.isArray(val) && val.length === 0) ||
      val === null ||
      val === undefined ||
      val === ""
    ) {
      this.valueChange.emit(null);
    } else {
      this.valueChange.emit(val);
    }
  }

  onSearchClick() {
    if (this.config?.key !== undefined) {
      this.searchClicked.emit({ key: this.config.key, value: this.value });
    } else {
      console.warn("No config.key available to emit search filter");
    }
  }

  onClearValue() {
    this.value = null;
    this.valueChange.emit(null);
  }

  onOptionsFilter(event: { filter?: string }) {
    if (!this.config?.lazy || !this.config?.key) {
      return;
    }

    this.skipNextVirtualScrollLazyLoad = true;

    this.optionsLazyLoad.emit({
      key: this.config.key,
      first: 0,
      rows: this.config?.pageSize,
      filter: event?.filter ?? "",
    });
  }
}
